{"version":"26.10.27-local-solo","id":"at.softline.lagerhaus.voecklabruck.softline.web","name":"Lagerhaus Vöcklabruck Softline"}